import { render, staticRenderFns } from "./policyDetailPopup.vue?vue&type=template&id=58c35196&scoped=true"
import script from "./policyDetailPopup.vue?vue&type=script&lang=js"
export * from "./policyDetailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c35196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c35196')) {
      api.createRecord('58c35196', component.options)
    } else {
      api.reload('58c35196', component.options)
    }
    module.hot.accept("./policyDetailPopup.vue?vue&type=template&id=58c35196&scoped=true", function () {
      api.rerender('58c35196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/dialog/policyDetailPopup.vue"
export default component.exports